import { render, staticRenderFns } from "./HomeWideBanner.vue?vue&type=template&id=6dccc520&scoped=true&"
import script from "./HomeWideBanner.vue?vue&type=script&lang=js&"
export * from "./HomeWideBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dccc520",
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BButton, BRow, BContainer, BJumbotron} from 'bootstrap-vue'
    installComponents(component, {BCol, BButton, BRow, BContainer, BJumbotron})
    

export default component.exports